import { sanitiseUrlForHost } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const locale = 'locale';
const prefix = 'prefix';

const useGoto = () => {
  const navigate = useNavigate();
  const params = useParams();

  const goToUrl = useCallback(
    (link: string) => (params[locale] ? `/${params[locale]}/${params[prefix]}/${link}` : `/${params[prefix]}/${link}`),
    [params]
  );

  const goToUrlFullyQualified = useCallback(
    (link: string) => sanitiseUrlForHost(goToUrl(link), location.host, true),
    [goToUrl]
  );

  const goTo = useCallback(
    (link: string) => {
      navigate(goToUrl(link));
    },
    [navigate, goToUrl]
  );

  return { goTo, goToUrl, goToUrlFullyQualified } as const;
};

export default useGoto;
